import { render, staticRenderFns } from "./featured-bank.vue?vue&type=template&id=29d940aa"
import script from "./featured-bank.vue?vue&type=script&lang=js"
export * from "./featured-bank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Rating: require('/var/www/components/rating/rating.vue').default,ButtonTypical: require('/var/www/components/button/button-typical.vue').default})
